import styles from './FooterLegalLinksContainer.module.scss';
import cx from 'classnames';

interface FooterLegalLinksContainerProps {
  children: React.ReactNode;
  isCheckout?: boolean;
  isFooterLinksSortActive?: boolean;
}

export const FooterLegalLinksContainer = ({
  children,
  isCheckout = false,
  isFooterLinksSortActive
}: FooterLegalLinksContainerProps) => (
  <div
    className={cx(
      'd-flex',
      isFooterLinksSortActive
        ? [styles['footer__legal__links_sort-container']]
        : [styles['footer__legal__links-container']],
      {
        [styles['footer__legal__links-container_border']]: !isCheckout
      }
    )}
  >
    {children}
  </div>
);
